import { apiGet, apiPost, apiPut } from "../utils";
import {
  GET_PRODUCT_MODEL_LIST,
  GET_PRODUCT_WEIGHT_LIST,
  GET_PRODUCT_GRADE_LIST,
  GET_PRODUCT_DESCRIPTION,
  GET_PRODUCT_METAFIELDS,
  TOGGLE_AUTOACCEPT_ORDERS,
  UPDATEOPERATIONALHOURS,
  TOGGLEPRINTINGPREFERENCE,
  GETUSERPREFERENCES,
  GENERATEWOOAUTHLINK,
  GETWOOCOMMERCEUPLOADSTATUS,
  UPDATECATEGORYMAP,
  UPDATEWOOPRICEPREFERENCE,
  GETCATEGORIESLIST,
  GENERATESHOPIFYAPPLINK,
  UPDATESHOPIFYPRODUCTMAP,
  UPDATESHOPIFYCATEGORYMAP,
  UPDATESHOPIFYPRICEPREFERENCE,
  GETSHOPIFYUPLOADSTATUS,
  USERINTEGRATIONS
} from "./apiConfig";

export const getProductModels = async (categoryId) => {
  return apiGet(`${GET_PRODUCT_MODEL_LIST}?categoryId=${categoryId}`);
};

export const getProductWeights = async (categoryId) => {
  return apiGet(`${GET_PRODUCT_WEIGHT_LIST}?categoryId=${categoryId}`);
};

export const getProductGrades = async (categoryId) => {
  return apiGet(`${GET_PRODUCT_GRADE_LIST}?categoryId=${categoryId}`);
};

export const getProductDescription = async (categoryId, modelId) => {
  return apiGet(
    `${GET_PRODUCT_DESCRIPTION}?categoryId=${categoryId}&modelId=${modelId}`
  );
};

export const getProductMetaFields = async (productId) => {
  return apiGet(`${GET_PRODUCT_METAFIELDS}?productId=${productId}`);
};

export const toggleAutoAcceptOrder = async (data) => {
  return apiPut(TOGGLE_AUTOACCEPT_ORDERS, data, {
    "Content-Type": "application/json",
  });
};
export const togglePrintingPreference = async (data) => {
  return apiPost(TOGGLEPRINTINGPREFERENCE, data, {
    "Content-Type": "application/json",
  });
};
export const updateOperationalHours = async (data) => {
  return apiPost(UPDATEOPERATIONALHOURS, data, {
    "Content-Type": "application/json",
  });
};
export const updateWooPriceSyncPreference = async (data) => {
  return apiPost(UPDATEWOOPRICEPREFERENCE, data, {
    "Content-Type": "application/json",
  });
};
export const updateWooProductCategoryMap = async (data) => {
  return apiPost(UPDATECATEGORYMAP, data, {
    "Content-Type": "application/json",
  });
};
export const getProductCategories = async () => {
  return apiGet(`${GETCATEGORIESLIST}`);
};
export const getUserPreference = async () => {
  return apiGet(`${GETUSERPREFERENCES}`);
};
export const getWooCommerceUploadStatus = async () => {
  return apiGet(`${GETWOOCOMMERCEUPLOADSTATUS}`);
};
export const getWooCommerceAuthLink = async (storeUrl) =>{
 return apiGet(`${GENERATEWOOAUTHLINK}?storeUrl=${storeUrl}`);
};

export const getShopifyAppLink = async (shopUrl) =>{
  return apiGet(`${GENERATESHOPIFYAPPLINK}?shopUrl=${shopUrl}`);
 };

 export const getShopifyUploadStatus = async () => {
  return apiGet(GETSHOPIFYUPLOADSTATUS);
};

export const updateShopifyPricePreference = async (data) => {
  return apiPost(UPDATESHOPIFYPRICEPREFERENCE, data, {
    "Content-Type": "application/json",
  });
};

export const updateShopifyCategoryMap = async (data) => {
  return apiPost(UPDATESHOPIFYCATEGORYMAP, data, {
    "Content-Type": "application/json",
  });
};

export const updateShopifyProductMap = async (data) => {
  return apiPost(UPDATESHOPIFYPRODUCTMAP, data, {
    "Content-Type": "application/json",
  });
};
export const getUserIntegrations = async () => {
  return apiGet(USERINTEGRATIONS);
};
